const moment = require('moment')

const DATE_FORMATS = [
  'YYYY-MM-DD',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
  'D-MM-YYYY',
  'DD-M-YYYY',
  'D-M-YYYY',
  'YYYY/MM/DD',
  'DD/MM/YYYY',
  'D/MM/YYYY',
  'YYYY.MM.DD',
  'DD.MM.YYYY',
  'DD/MMMM/YYYY',
  'DD/MMMM/YY',
  'DD/MM/YY',
  'DD-MMMM-YYYY',
  'DD-MMMM-YY',
  'DD-MM-YY',
  'DD.MMMM.YYYY',
  'DD.MMMM.YY',
  'DD.MM.YY',
  'DDMMMMYYYY',
  'DDMMMMYY',
  'DDMMYY',
  'D/M/Y',
  'D/MMMM/Y',
  'D MMMM Y',
]

const REPLACES = [
  // Swedish month names
  {
    searchValue: /januari/gi,
    replaceValue: 'january',
  },
  {
    searchValue: /februari/gi,
    replaceValue: 'february',
  },
  {
    searchValue: /mars/gi,
    replaceValue: 'march',
  },
  {
    searchValue: /maj/gi,
    replaceValue: 'may',
  },
  {
    searchValue: /juni/gi,
    replaceValue: 'june',
  },
  {
    searchValue: /juli/gi,
    replaceValue: 'july',
  },
  {
    searchValue: /augusti/gi,
    replaceValue: 'august',
  },
  {
    searchValue: /oktober/gi,
    replaceValue: 'october',
  },
]

function preprocess(input) {
  return REPLACES.reduce((value, { searchValue, replaceValue }) => value.replace(searchValue, replaceValue), input)
}

module.exports = function normalizeDate(input) {
  const date = moment(preprocess(input), DATE_FORMATS, true)

  if (!date.isValid()) return input

  return date.format('YYYY-MM-DD')
}

module.exports.DATE_FORMATS = DATE_FORMATS
